// @flow

import * as React from 'react';

import { Link } from 'react-router-dom';

import { useTranslator, mapTags, type TranslatorProps } from '@gandi/translate';

import withDomainConfigurationProps, {
  type DomainConfigurationProps,
  type OwnProps,
} from './withProps';

type Props = DomainConfigurationProps;

function getTranslation(
  __: TranslatorProps['__'],
  id: void | string,
  name: string,
  process: string,
  changeURL: false | string,
) {
  switch (true) {
    case !!id || process === 'create':
      return mapTags(__('[[templateName:]] applied'), () => ({
        templateName: changeURL ? <Link to={changeURL}>{name}</Link> : name,
      }));
    case process === 'transfer':
      return mapTags(
        __(
          "The domain's nameservers will not be changed during the transfer. [[changeLink:]]",
        ),
        () => ({
          changeLink: changeURL ? (
            <Link to={changeURL}>{__('Change')}</Link>
          ) : (
            ''
          ),
        }),
      );
    default:
      return null;
  }
}

const CellContents = ({
  process,
  committed,
  configuration,
  templateChangeURL,
}: Props) => {
  const { __ } = useTranslator();

  const payload = configuration?.payload || {};
  // XXX: we shouldn't pass an empty string
  const id = payload.template_id || '';
  const name = payload.template_name || __('Gandi default configuration');
  const locked = payload.locked || false;
  const label = getTranslation(
    __,
    id,
    name,
    process,
    !locked && !committed && templateChangeURL,
  );

  if (!label) {
    return null;
  }

  return <span>{label}</span>;
};

export default (withDomainConfigurationProps(
  CellContents,
): React.ComponentType<OwnProps>);
